module.exports = __webpack_public_path__ + "static/img/6.b974552.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/sp/6.png
// module id = MSpr
// module chunks = 0